var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGripVertical(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_980_10106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.4974 4.99967C7.95763 4.99967 8.33073 4.62658 8.33073 4.16634C8.33073 3.7061 7.95763 3.33301 7.4974 3.33301C7.03716 3.33301 6.66406 3.7061 6.66406 4.16634C6.66406 4.62658 7.03716 4.99967 7.4974 4.99967Z",
    stroke: "#636874",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.4974 10.8337C7.95763 10.8337 8.33073 10.4606 8.33073 10.0003C8.33073 9.54009 7.95763 9.16699 7.4974 9.16699C7.03716 9.16699 6.66406 9.54009 6.66406 10.0003C6.66406 10.4606 7.03716 10.8337 7.4974 10.8337Z",
    stroke: "#636874",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.4974 16.6667C7.95763 16.6667 8.33073 16.2936 8.33073 15.8333C8.33073 15.3731 7.95763 15 7.4974 15C7.03716 15 6.66406 15.3731 6.66406 15.8333C6.66406 16.2936 7.03716 16.6667 7.4974 16.6667Z",
    stroke: "#636874",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4974 4.99967C12.9576 4.99967 13.3307 4.62658 13.3307 4.16634C13.3307 3.7061 12.9576 3.33301 12.4974 3.33301C12.0372 3.33301 11.6641 3.7061 11.6641 4.16634C11.6641 4.62658 12.0372 4.99967 12.4974 4.99967Z",
    stroke: "#636874",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4974 10.8337C12.9576 10.8337 13.3307 10.4606 13.3307 10.0003C13.3307 9.54009 12.9576 9.16699 12.4974 9.16699C12.0372 9.16699 11.6641 9.54009 11.6641 10.0003C11.6641 10.4606 12.0372 10.8337 12.4974 10.8337Z",
    stroke: "#636874",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4974 16.6667C12.9576 16.6667 13.3307 16.2936 13.3307 15.8333C13.3307 15.3731 12.9576 15 12.4974 15C12.0372 15 11.6641 15.3731 11.6641 15.8333C11.6641 16.2936 12.0372 16.6667 12.4974 16.6667Z",
    stroke: "#636874",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_980_10106"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGripVertical);
export default __webpack_public_path__ + "static/media/grip-vertical.1e3f4133f6a915199bdf4c9444e02a80.svg";
export { ForwardRef as ReactComponent };